import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ahmad Mohammad </span>
            from <span className="purple"> Bellevue, TN.</span>
            <br />
            I am currently doing my MS in CS @ MTSU.
            <br />
            I am currently learning cloud platforms (AWS/GCP). In fact this webpage is hosted using GCP!
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games (Getting into Rust right now but too time demanding)
            </li>
            <li className="about-activity">
              <ImPointRight /> Fishing (Freshwater creeks and ponds)
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling (Recent destinations include Korea + NYC)
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Striving to build and innovate!"{" "}
          </p>
          <footer className="blockquote-footer">Ahmad</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
